module.exports = __webpack_public_path__ + "static/img/czheader2.a4ab86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/czheader2.png
// module id = 55
// module chunks = 0